import React, { useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import api from "../services/api";
import "./HospitalityAuditsPage.css";

const HospitalityAuditsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { locationId } = useParams();

  // Data passed immediately after upload
  const audit = location.state?.audit;

  const [reservations, setReservations] = useState([]);
  const [dailyFill, setDailyFill] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomMoves, setRoomMoves] = useState([]);
  const [adjustments, setAdjustments] = useState([]);
  const [advanceDeposits, setAdvanceDeposits] = useState([]);
  const [groupReservations, setGroupReservations] = useState([]);
  const [nightAudits, setNightAudits] = useState([]);
  const [occupancyCalendar, setOccupancyCalendar] =
  useState(null);
  const [finalAuditTotals, setFinalAuditTotals] =
  useState(null);

  const [selectedReportDate, setSelectedReportDate] =
  useState("");
  

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (
      audit?.brand &&
      audit.brand.toLowerCase() !==
        "hilton"
    ) {
      setLoading(false);
      return;
    }
      try {
        setLoading(true);
        setError("");

        const [
          reservationsRes,
          dailyFillRes,
          inventoryRes,
          roomTypesRes,
          roomMovesRes,
          adjustmentsRes,
          advanceDepositsRes,
          groupReservationsRes,
          nightAuditsRes,
          occupancyCalendarRes,
        ] = await Promise.all([
          api.get(
            `/hospitality/hilton/reservations/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/daily-fill/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/daily-inventory/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/room-types/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/room-moves/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/adjustments/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/advance-deposits/${locationId}`
          ),

          api.get(
            `/hospitality/hilton/group-reservations/${locationId}`
          ),

          api.get(
            `/hospitality/night-audits/${locationId}`
          ),
          api.get(
  `/hospitality/hilton/occupancy-calendar/${locationId}`
),
        ]);

        setReservations(reservationsRes.data || []);
        setDailyFill(dailyFillRes.data || []);
        setInventory(inventoryRes.data || []);
        setRoomTypes(roomTypesRes.data || []);
        setRoomMoves(roomMovesRes.data || []);
        setAdjustments(adjustmentsRes.data || []);
        setAdvanceDeposits(advanceDepositsRes.data || []);
        setGroupReservations(groupReservationsRes.data || []);
        setNightAudits(nightAuditsRes.data || []);
        setOccupancyCalendar(
  occupancyCalendarRes.data
);

      } catch (err) {
        setError(
          err?.response?.data?.message ||
          "Failed to load Hilton audit data."
        );
      } finally {
        setLoading(false);
      }
    };

    if (locationId) {
      fetchData();
    }
  }, [locationId]);


useEffect(() => {
  if (
    occupancyCalendar?.reportDate &&
    !selectedReportDate
  ) {
    setSelectedReportDate(
      String(
        occupancyCalendar.reportDate
      ).slice(0, 10)
    );
  }
}, [
  occupancyCalendar?.reportDate,
  selectedReportDate,
]);

  useEffect(() => {
  const fetchFinalAudit = async () => {
    if (
      !locationId ||
      !selectedReportDate
    ) {
      return;
    }

    try {
      const { data } = await api.get(
        `/hospitality/hilton/final-audit/${locationId}`,
        {
          params: {
            report_date: selectedReportDate,
          },
        }
      );

      setFinalAuditTotals(data);

    } catch (err) {
      setFinalAuditTotals(null);
    }
  };

  fetchFinalAudit();

}, [
  locationId,
  selectedReportDate,
]);

  if (loading) {
    return (
      <div className="hospitality-audits-page">
        <p>Loading Hilton data...</p>
      </div>
    );
  }



  if (
  audit?.brand?.toLowerCase() ===
  "seahaus"
) {
  const revenue =
    audit.parsed?.dailyRevenue;

  return (
    <div className="hospitality-audits-page">

      <button
        type="button"
        className="hospitality-audits-back"
        onClick={() =>
          navigate("/hospitality")
        }
      >
        Dashboard
      </button>

      <div className="hospitality-audits-header">
        <h1>Seahaus Night Audit</h1>
      </div>

      <div className="hospitality-report-totals-row">

        <div className="hospitality-report-totals">

          <div>
            <span>Report Date</span>
            <strong>
              {revenue?.reportDate || "-"}
            </strong>
          </div>

          <div>
            <span>
              Room Revenue Today
            </span>

            <strong>
              {revenue
                ? `$${Number(
                    revenue.roomRevenueToday
                  ).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`
                : "-"}
            </strong>
          </div>

          <div>
            <span>
              Room Revenue MTD
            </span>

            <strong>
              {revenue
                ? `$${Number(
                    revenue
                      .roomRevenueMonthToDate
                  ).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`
                : "-"}
            </strong>
          </div>

          <div>
            <span>
              Last Year MTD
            </span>

            <strong>
              {revenue
                ? `$${Number(
                    revenue
                      .roomRevenueLastYearMonthToDate
                  ).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`
                : "-"}
            </strong>
          </div>

          <div>
            <span>
              Room Revenue YTD
            </span>

            <strong>
              {revenue
                ? `$${Number(
                    revenue
                      .roomRevenueYearToDate
                  ).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`
                : "-"}
            </strong>
          </div>

          <div>
            <span>
              Last Year YTD
            </span>

            <strong>
              {revenue
                ? `$${Number(
                    revenue
                      .roomRevenueLastYearToDate
                  ).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`
                : "-"}
            </strong>
          </div>

        </div>

      </div>

    </div>
  );
}



  const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(
    date.getMonth() + 1
  ).padStart(2, "0");
  const day = String(
    date.getDate()
  ).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


const getOccupancyForDate = (date) => {
  const dateKey = formatDateKey(date);

  // -----------------------------------------
  // TODAY
  // -----------------------------------------

  const today = new Date();

  const todayKey = formatDateKey(today);


  // -----------------------------------------
  // PAST / TODAY
  //
  // Use actual Rooms Sold from
  // hilton_room_type_daily when available.
  // -----------------------------------------

  if (dateKey <= todayKey) {
    const roomTypeRows =
      roomTypes.filter(
        (row) =>
          String(row.report_date)
            .slice(0, 10) === dateKey
      );

    if (roomTypeRows.length > 0) {
      const roomsSold =
        roomTypeRows.reduce(
          (total, row) =>
            total +
            (Number(row.sold_rooms) || 0),
          0
        );

      const totalRooms =
        occupancyCalendar?.totalRooms || 0;

      const occupancyPercent =
        totalRooms > 0
          ? Number(
              (
                (roomsSold / totalRooms) *
                100
              ).toFixed(2)
            )
          : 0;

      return {
        date: dateKey,

        roomsBooked: roomsSold,

        totalRooms,

        occupancyPercent,

        source: "rooms-sold",
      };
    }
  }


  // -----------------------------------------
  // FUTURE
  //
  // Use hilton_daily_fill
  // -----------------------------------------

  if (!occupancyCalendar?.occupancy) {
    return null;
  }

  const dailyFillRow =
    occupancyCalendar.occupancy.find(
      (row) =>
        String(row.date)
          .slice(0, 10) === dateKey
    );

  if (!dailyFillRow) {
    return null;
  }

  return {
    ...dailyFillRow,

    source: "daily-fill",
  };
};


const buildCalendarMonth = (year, month) => {
  const firstDay =
    new Date(year, month, 1);

  const lastDay =
    new Date(year, month + 1, 0);

  const cells = [];

  // Empty boxes before first day
  for (
    let i = 0;
    i < firstDay.getDay();
    i++
  ) {
    cells.push(null);
  }

  for (
    let day = 1;
    day <= lastDay.getDate();
    day++
  ) {
    cells.push(
      new Date(year, month, day)
    );
  }

  return cells;
};


const getRoomTypeSummaryForDate = (reportDate) => {
  if (!reportDate) {
    return null;
  }

  const rowsForDate = roomTypes.filter(
    (row) =>
      String(row.report_date).slice(0, 10) ===
      reportDate
  );

  if (rowsForDate.length === 0) {
    return null;
  }

  const totals = rowsForDate.reduce(
    (acc, row) => {
      acc.totalRevenue +=
        Number(row.total_revenue) || 0;

      acc.roomRevenue +=
        Number(row.room_revenue) || 0;

      acc.roomsSold +=
        Number(row.sold_rooms) || 0;

      acc.vacantRooms +=
        Number(row.vacant_rooms) || 0;

      acc.totalRooms +=
        Number(row.room_available) || 0;

      return acc;
    },
    {
      totalRevenue: 0,
      roomRevenue: 0,
      roomsSold: 0,
      vacantRooms: 0,
      totalRooms: 0,
    }
  );

  const revPar =
    totals.totalRooms > 0
      ? totals.roomRevenue / totals.totalRooms
      : 0;

  const adr =
    totals.roomsSold > 0
      ? totals.roomRevenue / totals.roomsSold
      : 0;

  return {
    reportDate,

    totalRevenue:
      totals.totalRevenue,

    roomRevenue:
      totals.roomRevenue,

    roomsSold:
      totals.roomsSold,

    vacantRooms:
      totals.vacantRooms,

    totalRooms:
      totals.totalRooms,

    revPar,
    adr,
  };
};


const roomTypeTotals =
  getRoomTypeSummaryForDate(
    selectedReportDate
  );

  const getDepositSummaryForDate = (reportDate) => {
  if (!reportDate) {
    return null;
  }

  const rowsForDate = advanceDeposits.filter(
    (row) =>
      String(row.report_date).slice(0, 10) ===
      reportDate
  );

  if (rowsForDate.length === 0) {
    return null;
  }

  const totals = rowsForDate.reduce(
    (acc, row) => {
      acc.totalDepositsCollected +=
        Number(
          row.deposit_collected_until_date
        ) || 0;

      acc.depositsCollectedToday +=
        Number(
          row.deposit_collected_today
        ) || 0;

      return acc;
    },
    {
      totalDepositsCollected: 0,
      depositsCollectedToday: 0,
    }
  );

  return totals;
};

const selectedRoomTypes = roomTypes.filter(
  (row) =>
    String(row.report_date).slice(0, 10) ===
    selectedReportDate
);

const depositSummary =
  getDepositSummaryForDate(
    selectedReportDate
  );

const getCalendarMonths = () => {
  if (!occupancyCalendar?.reportDate) {
    return [];
  }

  // Important:
  // Parse manually so JS timezone does not
  // move the date backward/forward.
  const reportDateString =
    String(
      occupancyCalendar.reportDate
    ).slice(0, 10);

  const [
    year,
    month
  ] = reportDateString
    .split("-")
    .map(Number);

  const months = [];

  for (let i = 0; i < 3; i++) {
    months.push(
      new Date(
        year,
        month - 1 + i,
        1
      )
    );
  }

  return months;
};


  return (
    <div className="hospitality-audits-page">
<button
          type="button"
          className="hospitality-audits-back"
          onClick={() => navigate("/hospitality")}
        >
          Dashboard
        </button>
      <div className="hospitality-audits-header">
        
<div>
        <h1>Hilton Night Audit</h1>
        </div>
      </div>
      

      {error && (
        <div className="hospitality-audits-empty">
          {error}
        </div>
      )}

      {!error && !occupancyCalendar && (
  <div className="hospitality-audits-empty">
    No night audit data is available for this location yet.
  </div>
)}

      {/* ==========================================
          LOCATION / UPLOAD INFORMATION
      ========================================== */}

     

{/* ==========================================
    HOTEL SUMMARY
========================================== */}





<div className="hospitality-report-totals-row">

  <div className="hospitality-report-totals">

    <div>
      <span>Revenue Net Today</span>

      <strong>
        {finalAuditTotals
          ? `$${Number(
              finalAuditTotals.revenue_net_today
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-"}
      </strong>
    </div>


    <div>
      <span>Charges Net Today</span>

      <strong>
        {finalAuditTotals
          ? `$${Number(
              finalAuditTotals.charges_net_today
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-"}
      </strong>
    </div>


    <div>
      <span>Revenue MTD</span>

      <strong>
        {finalAuditTotals
          ? `$${Number(
              finalAuditTotals.revenue_mtd
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-"}
      </strong>
    </div>


    <div>
      <span>Charges MTD</span>

      <strong>
        {finalAuditTotals
          ? `$${Number(
              finalAuditTotals.charges_mtd
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-"}
      </strong>
    </div>

  </div>


  <div className="hospitality-report-date-picker">

    <label>Report Date</label>

    <input
      type="date"
      value={selectedReportDate}
      onChange={(e) =>
        setSelectedReportDate(
          e.target.value
        )
      }
    />

  </div>

</div>

{selectedReportDate &&
 !roomTypeTotals &&
 !finalAuditTotals && (
  <div className="hospitality-report-no-data">
    No report data available for {selectedReportDate}.
  </div>
)}

{occupancyCalendar && (
  <>

<div className="hospitality-hotel-summary-cards">
  <div className="hospitality-hotel-summary-card">
    <span>Total Revenue</span>

    <strong>
  {roomTypeTotals
    ? `$${roomTypeTotals.totalRevenue.toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`
    : "-"}
</strong>
  </div>


  <div className="hospitality-hotel-summary-card">
    <span>RevPAR</span>

   <strong>
  {roomTypeTotals
    ? `$${roomTypeTotals.revPar.toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`
    : "-"}
</strong>
  </div>
  <div className="hospitality-hotel-summary-card">
  <span>ADR</span>

  <strong>
  {roomTypeTotals
    ? `$${roomTypeTotals.adr.toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`
    : "-"}
</strong>
</div>


  <div className="hospitality-hotel-summary-card">
    <span>Rooms Sold</span>

    <strong>
  {roomTypeTotals
    ? roomTypeTotals.roomsSold
    : "-"}
</strong>
  </div>


  <div className="hospitality-hotel-summary-card">
    <span>Vacant Rooms</span>

    <strong>
  {roomTypeTotals
    ? roomTypeTotals.vacantRooms
    : "-"}
</strong>
  </div>
  

</div>
  </>
)}
{/* ==========================================
    OCCUPANCY CALENDAR
========================================== */}


{occupancyCalendar ? (
  <>
    
<div className="hospitality-calendar-layout">
<div className="hospitality-calendar-left">
    <div className="hospitality-calendar-months">

      {getCalendarMonths().map(
        (monthDate) => {

          const year =
            monthDate.getFullYear();

          const month =
            monthDate.getMonth();

          const cells =
            buildCalendarMonth(
              year,
              month
            );

          return (
            <div
              className="hospitality-calendar-month"
              key={`${year}-${month}`}
            >

              <h3>
                {monthDate.toLocaleDateString(
                  undefined,
                  {
                    month: "long",
                    year: "numeric",
                  }
                )}
              </h3>

              <div className="hospitality-calendar-weekdays">
                <div>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
              </div>

              <div className="hospitality-calendar-grid">

                {cells.map(
                  (date, index) => {

                    if (!date) {
                      return (
                        <div
                          key={`empty-${index}`}
                          className="hospitality-calendar-day hospitality-calendar-day-empty"
                        />
                      );
                    }

                    const occupancy =
                      getOccupancyForDate(
                        date
                      );

                    return (
                      <div
  key={formatDateKey(date)}
  className={`hospitality-calendar-day ${
    occupancy
      ? Number(occupancy.occupancyPercent) > 40
        ? "hospitality-occupancy-high"
        : Number(occupancy.occupancyPercent) >= 20
        ? "hospitality-occupancy-medium"
        : "hospitality-occupancy-low"
      : ""
  }`}
>

                        <div className="hospitality-calendar-date">
                          {date.getDate()}
                        </div>

                        {occupancy ? (
                          <>
                            <div className="hospitality-calendar-percent">
                              {occupancy.occupancyPercent}%
                            </div>

                            <div className="hospitality-calendar-rooms">
                              {occupancy.roomsBooked}
                              {" / "}
                              {occupancy.totalRooms}
                            </div>
                          </>
                        ) : (
                          <div className="hospitality-calendar-no-data">
                            -
                          </div>
                        )}

                      </div>
                    );
                  }
                )}

              </div>

            </div>
          );
        }
      )}

    </div>
    </div>

    <div className="hospitality-calendar-right">


    <div>


  {depositSummary ? (
    <>
      <div className="hospitality-calendar-deposit-item">
        <span>
          Total Deposits Collected
        </span>

        
          $
          {depositSummary
            .totalDepositsCollected
            .toLocaleString(
              "en-US",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}
       
      </div>


      <div className="hospitality-calendar-deposit-item">
        <span>
          Deposits Collected Today
        </span>

       
          $
          {depositSummary
            .depositsCollectedToday
            .toLocaleString(
              "en-US",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}
       
      </div>
    </>
  ) : (
    <div className="hospitality-calendar-deposit-empty">
      No deposit data available for{" "}
      {selectedReportDate}.
    </div>
  )}

  </div>

  <div>
      

      <div className="hospitality-audits-table-wrap">
        <table className="hospitality-audits-table hospitality-room-type-table">
          <thead>
            <tr>
          
              <th>Room Type</th>
            
              <th>Available</th>
              <th>Vacant</th>
              <th>Down</th>
              <th>Sold</th>
              <th>Room Revenue</th>
              <th>Other Revenue</th>
              <th>Total Revenue</th>
              <th>ADR</th>
            </tr>
          </thead>

          <tbody>
            {selectedRoomTypes.length === 0 ? (
              <tr>
                <td colSpan="11">
                  No room type records.
                </td>
              </tr>
            ) : (
              selectedRoomTypes.map((row) => (
                <tr key={row.id}>
                  
                  <td>{row.room_type_name}</td>
                
                  <td>{row.room_available}</td>
                  <td>{row.vacant_rooms}</td>
                  <td>{row.down_rooms}</td>
                  <td>{row.sold_rooms}</td>
                  <td>${row.room_revenue}</td>
                  <td>${row.other_room_revenue}</td>
                  <td>${row.total_revenue}</td>
                  <td>${row.adr}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      </div>



    

  </div>
    </div>
  </>
) : (
  <p>No occupancy calendar data.</p>
)}
      {/* ==========================================
          COUNTS
      ========================================== */}

      

      <div className="hospitality-audits-summary-grid">

        <div className="hospitality-audits-summary-card">
          <span>Reservations</span>
          <strong>{reservations.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Daily Fill</span>
          <strong>{dailyFill.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Room Types</span>
          <strong>{roomTypes.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Room Moves</span>
          <strong>{roomMoves.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Adjustments</span>
          <strong>{adjustments.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Advance Deposits</span>
          <strong>{advanceDeposits.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Group Reservations</span>
          <strong>{groupReservations.length}</strong>
        </div>

        <div className="hospitality-audits-summary-card">
          <span>Night Audits</span>
          <strong>{nightAudits.length}</strong>
        </div>

      </div>


      {/* ==========================================
          DAILY INVENTORY
      ========================================== */}

      <h2 style={{ marginTop: "35px" }}>
        Daily Inventory
      </h2>

      <div className="hospitality-audits-table-wrap">
        <table className="hospitality-audits-table">
          <thead>
            <tr>
             
              <th>Total Inventory</th>
              <th>Available</th>
              <th>Sold</th>
              <th>Down</th>
            </tr>
          </thead>

          <tbody>
            {inventory.length === 0 ? (
              <tr>
                <td colSpan="5">
                  No inventory records.
                </td>
              </tr>
            ) : (
              inventory.map((row) => (
                <tr key={row.id}>
              
                  <td>{row.total_inventory}</td>
                  <td>{row.available_rooms}</td>
                  <td>{row.sold_rooms}</td>
                  <td>{row.down_rooms}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>


      {/* ==========================================
          ROOM TYPE DAILY
      ========================================== */}



      {/* ==========================================
          RESERVATIONS
      ========================================== */}

      <h2 style={{ marginTop: "35px" }}>
        Reservations
      </h2>

      <div className="hospitality-audits-table-wrap">
        <table className="hospitality-audits-table">
          <thead>
            <tr>
              <th>Confirmation</th>
              <th>Guest</th>
              <th>Room</th>
              <th>Status</th>
              <th>Check In</th>
              <th>Check Out</th>
              <th>Nights</th>
              <th>Guests</th>
              <th>Rate</th>
            </tr>
          </thead>

          <tbody>
            {reservations.length === 0 ? (
              <tr>
                <td colSpan="9">
                  No reservation records.
                </td>
              </tr>
            ) : (
              reservations.map((row) => (
                <tr key={row.id}>
                  <td>{row.confirmation_number}</td>
                  <td>{row.guest_name || "-"}</td>
                  <td>{row.room_number || "-"}</td>
                  <td>{row.reservation_status || "-"}</td>
                  <td>{row.check_in_date}</td>
                  <td>{row.check_out_date}</td>
                  <td>{row.number_of_nights ?? "-"}</td>
                  <td>{row.number_of_guests ?? "-"}</td>
                  <td>
                    {row.room_rate !== null
                      ? `$${row.room_rate}`
                      : "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>


      {/* ==========================================
          ROOM MOVES
      ========================================== */}


      {/* ==========================================
          ADJUSTMENTS
      ========================================== */}


      {/* ==========================================
          ADVANCE DEPOSITS
      ========================================== */}


      {/* ==========================================
          DAILY FILL
      ========================================== */}

      


      {/* ==========================================
          RAW DEBUG DATA
      ========================================== */}

      {audit?.parsed && (
        <>
          <h2 style={{ marginTop: "35px" }}>
            Parsed Upload Debug
          </h2>

          <pre className="hospitality-audits-console">
            {JSON.stringify(
              audit.parsed,
              null,
              2
            )}
          </pre>
        </>
      )}

    </div>
  );
};

export default HospitalityAuditsPage;